import React from 'react';
import { Util, createIcon, Request, Notification, PromiseUtil, Storage } from "./common";
import App from './external/containers/App';
import { getConfig } from './external/containers/Apps';

export const PrincipalChanged = "principalChanged";

const authStorageKeyHeader = "PrincipalAuth";

function getAuthStorageKey(appName){
  appName = appName || App.current.name();
  if(!appName) throw Error("没有为当前应用域设置名称");
  return `${authStorageKeyHeader}-${appName}`;
}

export class Principal {

  static isMember() {
    return Principal.current() != null;
  }

  //同一个地址栏下，Principal._auth是共享1个，但是由于应用域的切换，也是在同一个地址栏下只有一个应用域，所以没问题
  //打开新地址栏，Principal._current是各自独立的，持久的数据，由各自的应用域独立保存
  static getAuth(appName){
    if (!Principal._auth) {
      let data = Storage.get(getAuthStorageKey(appName), null);
      if(!data) return null;
      Principal._auth = data;
    }
    return Principal._auth;
  }

  static setAuth({ Token, PermissionCodes, RoleCodes, Dark, IgnoreAuth, IgnoreDark }) {
    let cur = Principal.current();
    if (!cur) return; //没有登录者，返回

    let data = Principal.getAuth() ||{};
    data.Token = Token;
    data.PermissionCodes = PermissionCodes || [];
    data.RoleCodes = RoleCodes || [];
    data.Dark = Dark || false;
    data.IgnoreAuth = IgnoreAuth || false;
    data.IgnoreDark = IgnoreDark || false;
    //保存授权信息
    Principal._auth=data;
    Storage.set(getAuthStorageKey(), data);

    cur.fingers = [];//重新授权就清空指纹数据
  }

  static clearAuth(){
    Storage.removes((key)=>{  //清空所有与授权有关的存储信息
      return key.startsWith(`${authStorageKeyHeader}-`);
    });
    Principal._auth = null;
  }

  static refreshToken(token){
    let data = Principal.getAuth();
    if(!data) return;
    data.Token = token;
    Storage.set(getAuthStorageKey(), data);
  }

  static current() {
    if (!Principal._current) {
      let data = Storage.get("Principal", null);
      if (!data) return null;
      Principal._current = new Principal(data);
    }
    return Principal._current;
  }

  constructor(data) {
    this.id = data.Id || data.id;
    this.name = data.Name || data.name;
    this.data = data;
  }

  static setRealName(realName) {
    let cur = Principal.current();
    if (!cur) return;
    let data = cur.data;
    data.RealName = realName;
    Storage.set("Principal", data);
  }

  static getItem(key, defaultValue) {
    key = Principal.mapItemKey(key);
    let items = Principal.getItems();
    let value = items[key];
    return Util.invalid(value) ? defaultValue : value;
  }

  static setItem(key, value) {
    key = Principal.mapItemKey(key);
    let items = Principal.getItems();
    items[key] = value;
    Principal.setItems(items);
  }

  static mapItemKey(key) {
    return Principal.getItemKey ? Principal.getItemKey(key) : key;  //程序员可以自定义算法
  }

  static getItems() { //获得当前登录人的个性选项
    let cur = Principal.current();
    if (!cur) return;
    let id = cur.id;

    let data = Storage.get(`Principal_Items_${id}`, null);
    return data || {};
  }

  static setItems(items) { //获得当前登录人的个性选项
    let cur = Principal.current();
    if (!cur) return;
    let id = cur.id;

    Storage.set(`Principal_Items_${id}`, items);
  }

  // static setWeChatSubscribed(isSubscribed) {
  //   var data = Storage.get("Principal", null);
  //   if (data != null) {
  //     data.weChatSubscribed = isSubscribed;
  //     Storage.set("Principal", data);
  //     Principal.current = new Principal(data);
  //     EasyComponent.emitRefresh(Events.principalChanged);
  //   }
  // }

  static setPhoto(photo) {
    let cur = Principal.current();
    if (!cur) return;
    let data = cur.data;
    data.Photo = photo;
    Storage.set("Principal", data);
  }

  static finger(code, getAuth, evt) {  //通过指纹，为当前用户赋予权限，在登录期间有效
    let cur = Principal.current();
    if (!cur) return;
    if (!cur.fingers) cur.fingers = [];
    let cache = cur.fingers;
    if (cache.length >= 100) {
      cache = cur.fingers = cache.slice(0, 50);  //防止数据过多，内存增加，达到100个，就减去老的50个
    }

    let r = cache[code];
    if (!Util.invalid(r)) {
      //console.log(code);
      if (evt) {
        if (r && evt.success) evt.success();
        if (!r && evt.error) evt.error();
      }
      return r; //有数据
    }
    getAuth((auth) => {
      cache[code] = auth;
    });
  }

  // static setInviter(inviter) {
  //   var data = Storage.get("Principal", null);
  //   if (data != null) {
  //     data.inviter = inviter;
  //     Storage.set("Principal", data);
  //     Principal.current = new Principal(data);
  //     EasyComponent.emitRefresh(Events.principalChanged);
  //   }
  // }

  // static init() {

  //   var data = Storage.get("Principal", null);
  //   if (data == null) {
  //     data = { visitor: true };//默认为游客
  //     Storage.set("Principal", data);
  //   }
  //   Principal.current = new Principal(data);
  //   //EasyComponent.emitRefresh(Events.principalChanged);
  // }

  static get(ms) {
    let data = Storage.get("Principal", null);
    if (ms) {
      let t = {};
      ms.forEach((m) => {
        let n0, n1, dot = m.indexOf(':');
        if (dot == -1) {
          n0 = n1 = m;
        } else {
          n0 = m.substring(0, dot);
          n1 = m.substring(dot + 1);
        }
        t[n1] = data[n0];
      });
      return t;
    }
    return data;
  }

  static signIn(data) {
    Principal._current = null;
    Storage.set("Principal", data);
    Principal.setAuth(data);
    Demo.set(data);
  }

  static signOut(data) {
    Principal._current = null;
    Storage.remove("Principal");
    Principal.clearAuth();
  }

  // static logout() {
  //   if (!Principal.isMember()) return;
  //   var data = { visitor: true };//恢复游客状态
  //   Principal.current = new Principal(data);
  //   EasyComponent.emitRefresh(Events.principalChanged);
  //   Storage.set("Principal", data);

  //   //退出后，重新初始化购物车、搜索历史
  //   ShoppingCart.init();
  //   SearchHistory.init();
  //   Friend.init();
  // }

  //static current = null;
}

Request.on("process",(response)=>{  //截获request收到处理响应的事件
  let token = response.headers["c-token"];
  if (token) {
    //更新token
    Principal.refreshToken(token);
  }
});


export const Auth = {
  verify:auth,
  pipeline:pipeline
}

function pipeline(targets,evt){
  if(targets.length === 0) return true;
  evt=evt||{};
  let {before,success,error} = evt;
  if(before) before();

  let features = targets.map((target,i)=>{
    return new Promise((resolve, reject) => {
      auth(target,{ //异步验证的回调
        error:()=>{
          target.auth=false;
          resolve();
        },
        success:()=>{
          target.auth=true;
          resolve();
        }
      });
    });
  });

  PromiseUtil.queue(features).then(()=>{
    if(Util.first(targets,(t)=> t.auth)){
      success(targets);
    }
    else{
      error();
    }
  });
}


export function auth({ permission, role, dark },evt) {
  evt = evt||{};

  let error=(p)=>{
    if(evt.error) {
      // alert(0);
      evt.error(p||{});
    }
    return false;
  }

  let success=()=>{
    if(evt.success){
      // alert(1);
      evt.success();
    }
    return true;
  }

  if (dark && !inDark()) return error({dark:true});

  if (!permission && !role) return success();

  let p = Principal.getAuth();
  if (!p) return error(); //没登录就是游客，没有权限
  if (p.IgnoreAuth) return success(); //当前登录者是忽略权限验证的

  if (permission) {  //指定了需要的权限
    if (Util.type(permission) == 'array') permission = {items:permission};
    if (p && p.PermissionCodes) {
      let {items,data,url} = permission;
      for (let i = 0; i < items.length; i++) {
        let current = items[i];
        if(Util.invalid(current)) throw new Error("无效的权限配置"); //由于权限码升级，导致老权限码有可能失效，这里要主动提示
        if (Util.type(current) == "string") current = { c: current };
        let { c: code, s: scope } = current;
        if (p.PermissionCodes.indexOf(`(${code})`) > -1) {
          if (scope) return scope({data,url},{success,error});
          return success();
        }
      }
    }
  }

  if (role) { //指定了需要的角色
    if (Util.type(role) == 'string') role = [role];
    /* let p = Principal.current(); */
    if (p && p.RoleCodes) {
      for (let i = 0; i < role.length; i++) {
        let code = role[i];
        if(Util.invalid(code)) throw new Error("无效的角色配置"); //由于角色码升级，导致老权限码有可能失效，这里要主动提示
        if (p.RoleCodes.indexOf(`(${code})`) > -1) return success();
      }
    }
  }


  return error();
}

function inDark() {  //目前用户是否在灰度中，仅根据登录者来判断，不考虑游客，以后再扩展
  let p = Principal.getAuth();
  if(!p) return;
  return p.Dark || p.IgnoreDark;
}

export class Demo {

  static set(user) {
    if(!user) return;
    if (user.IsDemo){
      let demo = {id:user.Id, key:user.DemoKey};
      Storage.set("Demo", demo);
    }
  }

  static get(){
      let data = Storage.get("Demo", null);
      if(!data) return null;
      return data;
  }
}